
<section *ngIf="status">
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 10" />
        <circle cx="10" cy="10" r="4" [ngClass]="validaStatus(status)" />
    </svg>
    {{status}}
</section>